/**
 * Created by bszggg on 2019. 01. 14..
 */
/*
 https://www.npmjs.com/package/js-xlsx
 Example sheets (empty):
 {"Munkalap1":{"!cols":[[],[]]}}

 Example usage
 actualSheet["A1"] = new oCell(actualSheet["A1"]).setValue(33).setFBgColor("FFF200").val;
 actualSheet["A2"] = new oCell(actualSheet["A2"]).setValue(33).setFBgColor("FFF200").setFontColor('0000ff').val;
 actualSheet["B1"] = new oCell(actualSheet["B1"]).setValue(33).setFBgColor("CE181E").val;
 actualSheet["B2"] = new oCell(actualSheet["B2"]).setValue(33).setFBgColor("FFF200").setFontColor('0000ff').val;
 actualSheet["C4"] = new oCell(actualSheet["C4"]).setValue(33).setFBgColor("FFF200").val;
 */
import oCell from '@/helper/oCell';

/**
 * Manage an xlsx sheets
 * @param sheets
 * @returns {oSheetManager}
 */
const oSheetManager = function (sheets) {
    if (typeof sheets === "undefined") {
        this.sheets = {
            Munkalap1: {}
        };
    } else {
        this.sheets = sheets;
    }
    return this;
};
oSheetManager.prototype.getSheetNames = function () {
    let SheetNames = [];
    for (let i in this.sheets) {
        if (!this.sheets.hasOwnProperty(i)) {
            continue;
        }
        SheetNames.push(i);
    }
    return SheetNames;
};

oSheetManager.prototype.getSheets = function (opts) {
    if (!opts) {
        opts = {}
    }
    const defaultOpts = {cutColsAfterFrom1024: true};
    opts = Object.assign(defaultOpts, opts);
    for (let sheetIndex in this.sheets) {
        if (this.sheets.hasOwnProperty(sheetIndex)) {
            const actualSheet = this.sheets[sheetIndex];
            // Set sheet max size by keys
            let a = [];
            let b = [];
            for (let sheetIndex2 in actualSheet) {
                if (actualSheet.hasOwnProperty(sheetIndex2)) {
                    if (sheetIndex2.charAt(0) !== '!') {
                        a.push(sheetIndex2.match(/[a-zA-Z]/g).join(''));
                        b.push(Number(sheetIndex2.match(/[0-9]/g).join('')));
                    }
                }
            }
            a = a.sort();
            b.sort(function (a, b) {
                return a - b;
            });
            const strKey = a[a.length - 1] + b[b.length - 1];
            if(a.length===0&&b.length===0){
              actualSheet['!ref'] = null;
            } else{
              actualSheet['!ref'] = 'A1:' + strKey;
            }
            if (opts.cutColsAfterFrom1024) {
                // Data filter over 1024
                if (Array.isArray(actualSheet['!cols'])) {
                    let cols = actualSheet['!cols'];
                    let newCols = [];
                    Array.prototype.forEach.call(cols, function (e, i) {
                        if (i < 1024) {
                            newCols.push(e);
                        }
                    });
                    actualSheet['!cols'] = newCols;
                }
            }
        }
    }
    return this.sheets;
};
oSheetManager.prototype.getSheet = function (index = 0) {
    const SheetNames = this.getSheetNames();
    return this.sheets[SheetNames[index]];
};
oSheetManager.prototype.getSheetByName = function (name = "") {
    const SheetNames = this.getSheetNames();
    let ret=false;
    if(this.sheets[name]){
      ret=this.sheets[name]
    }
    return ret;
};
oSheetManager.prototype.setSheets = function (sheets) {
    this.sheets = sheets;
    return this;
};
oSheetManager.prototype.getColumnNameByNumber = function (nNum) {
    if (nNum === 0) {
        console.warn("ERROR: THE SHEET INDEXING STARTS TO 1, NOT 0 !")
    }
    let charCodeOfA = "A".charCodeAt(0), alphabetLength = "Z".charCodeAt(0) - charCodeOfA + 1;
    const convertNumberToLetter = function (nNum) {
        const charCode = charCodeOfA + nNum - 1;
        return String.fromCharCode(charCode);
    };
    if (nNum <= alphabetLength) {
        return convertNumberToLetter(nNum);
    } else {
        const firstNumber = Math.floor((nNum - 1) / alphabetLength);
        const firstLetter = convertNumberToLetter(firstNumber);
        const secondNumber = (nNum % alphabetLength) || alphabetLength;
        const secondLetter = convertNumberToLetter(secondNumber);
        return firstLetter + secondLetter;
    }
};
oSheetManager.prototype.getColumnNumberByName = function (valChar) {
    let val = valChar.toUpperCase();
    let base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i, j, result = 0;
    for (i = 0, j = val.length - 1; i < val.length; i += 1, j -= 1) {
        result += Math.pow(base.length, j) * (base.indexOf(val[i]) + 1);
    }
    return result;
};
oSheetManager.prototype.reportBgColorer = function (actualSheet, id, type = "row", color, range = [1, 13]) {
  {
    const that = this;
    if (typeof id !== "number") {
      return;
    }
    if (type === "row") {
      for (let e = range[0]; e <= range[1]; e++) {
        let letter = that.getColumnNameByNumber(Number(e));
        actualSheet[letter + id] = new oCell(actualSheet[letter + id]).setBgColor(color).val;
      }
    } else if (type === "col") {
      Array.prototype.forEach.call(range, function (e, i) {
        let letter = that.getColumnNameByNumber(Number(id));
        actualSheet[letter + e] = new oCell(actualSheet[letter + e]).setBgColor(color).val;
      })
    }
  }
};

export default oSheetManager;

